export default "__VITE_ASSET__DiP$zCsH__";